export const RESET_TEXT = 'RESET_TEXT' as const

export const resetTextAction = () => ({
  type: RESET_TEXT,
})
